/**
 * Not penceresi için porsiyonları ikiye ayırır (20 Eki 2026): adisyona
 * kaydedilmiş, mutfağa gitmiş olanlar (kilitli) ve sonradan eklenenler.
 * Sepetteki porsiyonlardan gönderilmişlerin notları birer birer düşülüyor;
 * kalanlar yeni. Sepette gönderilenden az porsiyon varsa (adet azaltıldı)
 * kilitli olanlar da o kadar.
 */
export function splitPortions(inCart: string[], sentNotes: string[]): { sent: string[]; fresh: string[] } {
  const fresh = [...inCart]
  const sent: string[] = []
  for (const n of sentNotes) {
    const i = fresh.indexOf(n)
    if (i < 0) continue
    fresh.splice(i, 1)
    sent.push(n)
  }
  return { sent, fresh }
}
